/**
 *
 * Recommendations
 *
 */

import React, { Fragment } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import { Button, Empty, Input, Select, Spin } from "antd"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { deleteRecommendationApi } from "services/actionPlans"
import { orderBy, filter, isEqual, flatMap } from "lodash"
import emptyStateRecommendations from "images/empty-state-recommendations.svg"
import ModalRecommendationCreate from "components/ModalRecommendationCreate"
import ModalCustom from "components/ModalCustom"
import alertSvg from "images/alert.svg"
import {
  makeSelectRecommendationsList,
  makeSelectDimensionsList,
  makeSelectIsLoading,
} from "./selectors"
import { getRecommendationsWatcher } from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import TableRecommendations from "./Table"
import "./index.less"
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons"
import { buttonAction_btns } from "../../../components/Snowplow/config2"

/* eslint-disable react/prefer-stateless-function */
export class Recommendations extends React.Component {
  state = {
    selectedDimension: "",
    searchText: "",
    modalRecommendationEditId: null,
    ModalRecommendationCreate: false,
    modalDeleteRecommendationLoading: false,
    modalDeleteRecommendation: false,
    currentRecommendation: {},
    can_create_recommendation: false,
  }

  componentDidMount = () => {
    this.props.getRecommendations()
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { recommendations, isLoading } = nextProps
    if (!isEqual(nextProps, this.props)) {
      this.props.setCountTitle({
        show:
          Array.isArray(recommendations) &&
          (recommendations.length === 0) === false &&
          !isLoading,
        count: recommendations.length,
      })
    }
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  showDataBySearch = () => {
    const { searchText, selectedDimension = "" } = this.state

    if (searchText || selectedDimension) {
      return filter(this.props.recommendations, (item) => {
        return (
          item.name.toLowerCase().includes(searchText.toLocaleLowerCase()) &&
          item.dimensions_names
            .toLowerCase()
            .includes(selectedDimension.toLowerCase())
        )
      })
    }

    return Array.isArray(this.props.recommendations)
      ? this.props.recommendations
      : []
  }

  renderEmptyState = () => {
    const { can_create_recommendation } = this.state
    return (
      <div className="Recommendations-Empty">
        <Empty
          style={{ color: "#828282" }}
          image={emptyStateRecommendations}
          description={
            <Fragment>
              <span style={{ margin: "20px auto", display: "block" }}>
                Aún no cuentas con <b>Recomendaciones creadas.</b>
              </span>
              <span className="Recommendations-Empty-dashed">
                Las <b>Recomendaciones</b> te permiten crear planes de acción{" "}
                <b>modelo</b> que luego los embajadores de tu organización
                podrán visualizar y seleccionar al momento de crear sus propios
                planes de acción.
              </span>
              {can_create_recommendation && (
                <Button
                  className="btn-orange"
                  onClick={() => {
                    this.setState({ modalRecommendationCreate: true })
                    buttonAction_btns("Agregar recomendacion")
                  }}>
                  Agregar recomendación
                </Button>
              )}
            </Fragment>
          }
        />
      </div>
    )
  }

  render() {
    const {
      modalRecommendationCreate,
      modalRecommendationEditId,
      searchText,
      modalDeleteRecommendationLoading,
      modalDeleteRecommendation,
      currentRecommendation,
      can_create_recommendation,
    } = this.state
    const { recommendations, isLoading, dimensions } = this.props

    return (
      <div className="Recommendations" >
        {isLoading ? (
          <div className="loadingSpin">
            <Spin size="large" />
          </div>
        ) : recommendations.length === 0 ? (
          this.renderEmptyState()
        ) : (
          <Fragment>
            <div className="Recommendations-Header-buttons">
              {can_create_recommendation && (
                <Button
                  type="primary"
                  onClick={() => {
                    buttonAction_btns("Agregar recomendacion")
                    this.setState({ modalRecommendationCreate: true })
                  }}>
                  Agregar recomendación
                </Button>
              )}
            </div>
            <div style={{ margin: "13px 2rem" }}>
              <p>
                Las <b>Recomendaciones</b> te permiten crear planes de acción{" "}
                <b>modelo</b> que luego los embajadores de tu organización
                podrán visualizar y seleccionar al momento de crear sus propios
                planes de acción.
              </p>
            </div>
            <div className="Recommendations-Filters">
              <Input
                placeholder="Buscar..."
                style={{ width: 300 }}
                value={searchText}
                onChange={(e) =>
                  this.setStateFrom("searchText", e.target.value)
                }
                suffix={
                  searchText ? (
                    <CloseCircleOutlined
                      style={{
                        cursor: "pointer",
                        color: "white",
                        background: "rgba(0, 0, 0, 0.25)",
                        borderRadius: "50%",
                      }}
                      onClick={() => this.setStateFrom("searchText", "")}
                    />
                  ) : (
                    <SearchOutlined />
                  )
                }
              />

              <Select
                style={{ width: 200 }}
                placeholder="Seleccionar dimensión"
                onChange={(e) => this.setState({ selectedDimension: e })}
                allowClear>
                {dimensions.map((d, di) => (
                  <Select.Option key={di} value={d}>
                    {d}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className="Recommendations-Blocks">
              <TableRecommendations
                data={this.showDataBySearch()}
                onEdit={(e) => {
                  this.setState({
                    modalRecommendationCreate: true,
                    modalRecommendationEditId: e.id_recommendation,
                  })
                }}
                onDelete={(e) => {
                  this.setState({
                    modalDeleteRecommendation: true,
                    currentRecommendation: e,
                  })
                }}
              />
            </div>
          </Fragment>
        )}

        <ModalRecommendationCreate
          visible={modalRecommendationCreate}
          modalRecommendationEditId={modalRecommendationEditId}
          onCancel={() =>
            this.setState({
              modalRecommendationCreate: false,
              modalRecommendationEditId: null,
            })
          }
          canCreate={(value) => {
            this.setState({ can_create_recommendation: value })
          }}
          finish={() => {
            this.props.getRecommendations()
            // this.onFilter();
            this.setState({ modalRecommendationEditId: null })
          }}
        />
        <ModalCustom
          modalOpen={modalDeleteRecommendation}
          showFooter
          textButton="Eliminar"
          onOk={async () => {
            this.setState({ modalDeleteRecommendationLoading: true })
            try {
              const result = await deleteRecommendationApi({
                id: currentRecommendation.id_recommendation,
              })
              this.setState({
                modalDeleteRecommendation: false,
                modalDeleteRecommendationLoading: false,
                currentPlan: {},
              })
              this.props.getRecommendations()
              returnMessage(result)
            } catch (error) {
              this.setState({
                modalDeleteRecommendation: false,
                modalDeleteRecommendationLoading: false,
              })
              returnMessage(error)
            }
          }}
          onCancel={() => {
            this.setState({ modalDeleteRecommendation: false })
          }}
          isLoadingButton={modalDeleteRecommendationLoading}>
          <div className="component-deletesimple">
            <img src={alertSvg} className="alertIcon" alt="alert-svg" />
            <div className="component-deletesimple__description">
              <p>
                <b>¿Estas seguro de que deseas eliminar el plan de acción?</b>
              </p>
              <p>
                Los cambios no serán reversibles y el plan se borrará de forma
                permanente.
              </p>
            </div>
          </div>
        </ModalCustom>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  recommendations: makeSelectRecommendationsList(),
  dimensions: makeSelectDimensionsList(),
})

function mapDispatchToProps(dispatch) {
  return {
    getRecommendations: (params) => dispatch(getRecommendationsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "recommendations", reducer })
const withSaga = injectSaga({ key: "recommendations", saga })

export default compose(withReducer, withSaga, withConnect)(Recommendations)
